import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

const messages: { [key: string]: MessageDescriptor } = defineMessages({
	includeLinks: {
		id: 'issue-create-commons.issue-links-field.include-links',
		defaultMessage: 'Include links',
		description: 'Checkbox label to copy the source issue links to the new issue',
	},
	includeAttachments: {
		id: 'issue-create-commons.issue-links-field.include-attachments',
		defaultMessage: 'Include attachments',
		description: 'Checkbox label to copy the source issue attachments to the new issue',
	},
});

export default messages;
